import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";

export interface CaseResponse {
  id: string;
  caseEntityId: string;
  responseCode: string;
  otherResponseDescription?: string;
  responseDetails?: string;
  interimResponseNumber?: string;
  dateIssued: string;
  progressStatus?: string;
  preliminaryFindings?: string;
  challengesEncountered?: string;
  expectedFinalResponseDate?: string;
  clarificationNeeded: boolean;
  additionalDocumentationRequired: boolean;
  additionalRequirementsDetails?: string;
  canShareWithLEAs?: boolean;
  sharingNotAllowedReason?: string;
}

export type CreateCaseResponse = Omit<CaseResponse, "id">;

interface JsonResponse<T> {
  value: T;
}

@Injectable({
  providedIn: 'root'
})
export class CaseResponseService {
  constructor(private _http: HttpClient) { }

  getResponses(caseEntityId: string): Observable<CaseResponse[]> {
    return this._http.get<CaseResponse[]>(`${environment.apiUrl}/api/case-entity/${caseEntityId}/responses`);
  }

  createResponse(caseEntityId: string, response: CreateCaseResponse): Observable<JsonResponse<string>> {
    return this._http.post<JsonResponse<string>>(`${environment.apiUrl}/api/case-entity/${caseEntityId}/responses`, response);
  }
}
